import { render, staticRenderFns } from "./es-AR.vue?vue&type=template&id=2b7f0104&scoped=true&"
var script = {}
import style0 from "./es-AR.vue?vue&type=style&index=0&id=2b7f0104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f0104",
  null
  
)

export default component.exports